import type { FC } from 'react';
import React from 'react';
import { Tag } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';

interface FrostyBadgeProps {
  readonly text: string;
  readonly icon?: 'charging';
  readonly type: 'read-only' | 'encourage';
}

export const FrostyBadge: FC<FrostyBadgeProps> = ({ text, icon, type = 'read-only' }) => (
  <StyledTag
    data-testid="frostyBadge"
    label={text}
    margin={[0, 0, 0, 0]}
    size="sm"
    icon={icon}
    className="tag"
    variant={type}
  />
);
const StyledTag = styled(Tag)`
  display: flex;
  gap: var(--spacing-relative-xs);
  align-items: center;
`;
